import pluralize from 'pluralize';
import convert from 'convert-units';

class ProductCalculators {
  constructor() {
    this.calculatorLiner();
    this.calculatorVolume();
    this.calculateTankVolume();
  }


  calculatorLiner() {
    if (!document.getElementById('Calculate')) {
      return;
    }

    const calcSubmit = document.getElementById('Calculate');
    const pondLengthEl = document.getElementById('liner-length');
    const pondWidthEl = document.getElementById('liner-width');
    const pondDepthEl = document.getElementById('liner-depth');

    const measurementEl = document.querySelectorAll('input[name="calc[unit]"]');
    const fieldArr = [pondLengthEl, pondWidthEl, pondDepthEl];

    // for (let i = 0; i < measurementEl.length; i++) {
    //   const radio = measurementEl[i];
    //   if (radio.checked) {
    //     for (let field = 0; field < fieldArr.length; field++) {
    //       fieldArr[field].setAttribute('placeholder', radio.value);
    //       console.log(fieldArr[field]);
    //     }
    //   }
    // }

    measurementEl.forEach((radio) => {
      radio.addEventListener('change', (evt) => {
        fieldArr.forEach((field) => {
          field.setAttribute('placeholder', evt.target.dataset.unit);
        });
      });
    });

    const linerCalc = () => {
      const measurementUnit = document.querySelector('input[name="calc[unit]"]:checked').dataset.unit;

      const pondSize = {
        length: pondLengthEl.value,
        width: pondWidthEl.value,
        depth: pondDepthEl.value,
      };

      const linerLength = (pondSize.length * pondSize.depth);
      const linerWidth = (pondSize.width * pondSize.depth);

      if (linerLength <= 6 && linerWidth <= 6 && linerLength > linerWidth) {
        const temp = pondSize.length;
        pondSize.length = pondSize.width;
        pondSize.width = temp;
      }

      const pondWidth = Math.ceil(convert(linerWidth).from(measurementUnit).to('m'));
      const pondLength = Math.ceil(convert(linerLength).from(measurementUnit).to('m'));
      let result;

      $.each(pondSize, (key, value) => {
        if (value === '') {
          result = `
          <hr class="card__separator">
          <p class="result result--error">Please fill all fields.</p>`;
          return result;
        } else {
          result = `
          <hr class="card__separator">
          <p class="result">The length of pond liner I require is: <strong>${pondLength.toLocaleString()} ${pluralize('metre', pondLength)}</strong></p>
          <p class="result">The width of pond liner I require is: <strong>${pondWidth.toLocaleString()} ${pluralize('metre', pondWidth)}</strong></p>`;
          return result;
        }
      });

      document.getElementById('CalculatorResults').innerHTML = result;
    };

    calcSubmit.addEventListener('click', linerCalc, false);
  }

  calculatorVolume() {
    if (!document.getElementById('CalculateVolume')) {
      return;
    }
    const conversionValues = {
      gallons: {
        factor: 6.25,
        unit: 'gal',
      },
      litres: {
        factor: 1000,
        unit: 'l',
      },
    };

    const calcSubmit = document.getElementById('CalculateVolume');
    const pondLengthEl = document.getElementById('volume-length');
    const pondWidthEl = document.getElementById('volume-width');
    const pondDepthEl = document.getElementById('volume-depth');

    const volumeCalc = () => {
      const measurementUnit = document.querySelector('input[name="unitVolume"]:checked').dataset.unit;

      const factor = conversionValues[measurementUnit].factor;

      const pondSize = {
        length: pondLengthEl.value,
        width: pondWidthEl.value,
        depth: pondDepthEl.value,
      };

      const pondVolume = (pondSize.length * pondSize.width * pondSize.depth) * factor;
      let result;

      $.each(pondSize, (key, value) => {
        if (isNaN(value)) {
          result = `
          <hr class="card__separator">
          <p class="result result--error">Please fill all fields.</p>`;
          return false;
        } else {
          result = `
          <hr class="card__separator">
          <p class="result">Your pond contains approx: <strong>${pondVolume.toLocaleString()} ${pluralize(measurementUnit, pondVolume)}</strong> of water.</p>`;

          return result;
        }
      });

      document.getElementById('VolumeCalculatorResults').innerHTML = result;
    };


    // const unitRadios = document.getElementsByClassName('radio--volume');
    // const fieldArr = [pondLengthEl, pondWidthEl, pondDepthEl];
    // for (let i = 0; i < unitRadios.length; i++) {
    //   console.log(unitRadios[i]);
    //   unitRadios[i].addEventListener('change', function() {
    //     const selectedUnit = this.value;

    //     for (let index = 0; index < fieldArr.length; index++) {
    //       const field = fieldArr[index];
    //       field.setAttribute('placeholder', conversionValues[selectedUnit].unit);
    //     }
    //   });
    // }

    calcSubmit.addEventListener('click', volumeCalc, false);

  }

  calculateTankVolume() {
    if (!document.getElementById('CalculateTankVolume')) {
      return;
    }

    const conversionValues = {
      gallons: {
        factor: 6.25,
        unit: 'gal',
      },
      litres: {
        factor: 1000,
        unit: 'l',
      },
    };

    const calcSubmit = document.getElementById('CalculateTankVolume');
    const pondLengthEl = document.getElementById('tank-volume-length');
    const pondWidthEl = document.getElementById('tank-volume-width');
    const pondDepthEl = document.getElementById('tank-volume-depth');

    const tankVolumeCalc = () => {
      const measurementUnit = document.querySelector('input[name="unitTankVolume"]:checked').dataset.unit;
      const factor = conversionValues[measurementUnit].factor;

      const pondSize = {
        length: pondLengthEl.value,
        width: pondWidthEl.value,
        depth: pondDepthEl.value,
      };

      const pondVolume = (pondSize.length * pondSize.width * pondSize.depth) * factor;
      let result;

      $.each(pondSize, (key, value) => {
        if (isNaN(value)) {
          result = `
          <hr class="card__separator">
          <p class="result result--error">Please fill all fields.</p>`;
          return false;
        } else {
          result = `
          <hr class="card__separator">
          <p class="result">Your pond contains approx: <strong>${pondVolume.toLocaleString()} ${pluralize(measurementUnit, pondVolume)}</strong> of water.</p>`;

          return result;
        }
      });

      document.getElementById('TankVolumeCalculatorResults').innerHTML = result;
    };


    // const unitRadios = document.getElementsByClassName('radio--tank-volume');
    // const fieldArr = [pondLengthEl, pondWidthEl, pondDepthEl];
    // for (let i = 0; i < unitRadios.length; i++) {
    //   unitRadios[i].addEventListener('change', function() {
    //     const selectedUnit = this.value;

    //     for (let index = 0; index < fieldArr.length; index++) {
    //       const field = fieldArr[index];
    //       field.setAttribute('placeholder', conversionValues[selectedUnit].unit);
    //     }
    //   });
    // }

    calcSubmit.addEventListener('click', tankVolumeCalc, false);
  }
}

export default ProductCalculators;
